import * as React from "react";
const SvgFiRrBowling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowling_svg__a)">
      <path
        fill="#062147"
        d="M16 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-1a1 1 0 1 0 0 1.999A1 1 0 0 0 19 15m-2-3a1 1 0 1 0 0 1.999A1 1 0 0 0 17 12m7 4a7.99 7.99 0 0 1-13.194 6.073A4 4 0 0 1 7.39 24H4.61a4 4 0 0 1-3.624-2.3A11.1 11.1 0 0 1 0 17a11.8 11.8 0 0 1 1.736-5.463A8.44 8.44 0 0 0 3 8c-.114-.741-.3-1.47-.554-2.175A7.2 7.2 0 0 1 2 4a4 4 0 0 1 8 0 7.2 7.2 0 0 1-.446 1.825C9.3 6.53 9.114 7.259 9 8a6.7 6.7 0 0 0 .907 2.839A7.987 7.987 0 0 1 24 16M4 4c.016.15.211.772.354 1.226.338.892.555 1.825.646 2.774h2c.09-.95.308-1.882.646-2.774A12 12 0 0 0 8 3.973 2 2 0 0 0 4 4m5.2 16.856A9.1 9.1 0 0 0 10 17a10.1 10.1 0 0 0-1.512-4.542A18.4 18.4 0 0 1 7.368 10H4.632a18.4 18.4 0 0 1-1.12 2.458A10.1 10.1 0 0 0 2 17a9.1 9.1 0 0 0 .8 3.857A2 2 0 0 0 4.61 22h2.78a2 2 0 0 0 1.81-1.144M22 16a5.99 5.99 0 0 0-11.084-3.163A9.66 9.66 0 0 1 12 17c0 1.033-.137 2.062-.408 3.059A5.993 5.993 0 0 0 22 16"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowling_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowling;
